/* eslint-disable react/prop-types */
// Argon Dashboard 2 MUI components
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";
import ArgonAvatar from "components/ArgonAvatar";
import ArgonBadge from "components/ArgonBadge";

import VisibilityIcon from '@mui/icons-material/Visibility';
import DeleteIcon from '@mui/icons-material/Delete';

// Images
import team2 from "assets/images/team-2.jpg";
import team3 from "assets/images/team-3.jpg";
import team4 from "assets/images/team-4.jpg";
import { Button } from "@mui/material";
import { Link } from "react-router-dom";

function Author({ image, name, email }) {
 
  return (
    <ArgonBox display="flex" alignItems="center" px={0.5} py={0.1}>
      <ArgonBox mr={2}>
        <ArgonAvatar src={image} alt={name} size="sm" variant="full"/>
      </ArgonBox>
      <ArgonBox display="flex" flexDirection="column">

          {/* <Button variant="caption"  size="medium" component={Link} to="/ehc/viewehc" sx={{minWidth:"12px",p:0,color:"primary"}} >
                    {name}
           </Button> */}
        <ArgonTypography variant="caption" fontWeight="medium">
          {name}
        </ArgonTypography>
        <ArgonTypography variant="caption" color="secondary">
          {email}
        </ArgonTypography>
      </ArgonBox>
    </ArgonBox>
  );
}

function Function({ job, org }) {
  return (
    <ArgonBox display="flex" flexDirection="column">
      <ArgonTypography variant="caption" fontWeight="medium" color="text">
        {job}
      </ArgonTypography>
      <ArgonTypography variant="caption" color="secondary">
        {org}
      </ArgonTypography>
    </ArgonBox>
  );
}

function StudentData({student,client}){
    return(
      <ArgonBox display="flex" flexDirection="column">
        <ArgonTypography variant="caption" color="text" fontWeight="medium">{student}</ArgonTypography>
        <ArgonTypography variant="caption" color="text" fontWeight="medium">Client-{client}</ArgonTypography>
      </ArgonBox>
    )
}

// Attendance component
function AttendanceProgress({ percentage, label = "Attendance" }) {
  return (
    <ArgonBox>
      {/* Label */}
      <ArgonBox display="flex" justifyContent="space-between" mb={1}>
        <ArgonTypography variant="caption" fontWeight="medium" color="text">
          {"12 July 2024"}
        </ArgonTypography>
        
      </ArgonBox>
      
      {/* Progress Bar Container */}
      <ArgonBox
        width="180%"
        height="10px"
        bgColor="grey-200"
        borderRadius="lg"
        position="relative"
        overflow="hidden"
      >
        {/* Progress Fill */}
        <ArgonBox
          width={`${percentage}%`}
          height="100%"
          // bgColor={percentage >= 80 ? "success" : percentage >= 60 ? "warning" : "error"}
          bgColor="primary"
          borderRadius="lg"
          position="absolute"
          top={0}
          left={0}
        />
      </ArgonBox>
    </ArgonBox>
  );
}






const authorsTableData = {
  columns: [

    // { name: "author", align: "left" },
    // { name: "function", align: "left" },
    // { name: "status", align: "center" },
    // { name: "employed", align: "center" },
    // { name: "action", align: "center" },

    {name:"sno",align:"center"},
    {name:"Supervisor",align:"left"},
    {name:"Date", align:"left"},
    {name:"Time Slot", align:"left"},
    {name:"	Comment/Feedback",align:"left"},
     {name:"EHC Name", align:"left"},
  ],


 
  rows: [
  {
    sno1: <ArgonTypography variant="caption" color="text" fontWeight="medium">1</ArgonTypography>,
    "Parent Name & Mobile": <Author image={team2} name="Rajesh Sharma" email="9876543210" />,
    "Educator Name & Mobile": <Author image={team3} name="Dr. Priya Patel" email="9123456789" />,
    "Invegilator Date & Time": <ArgonTypography variant="caption" color="text" fontWeight="medium">15 Dec 2024, 10:00 AM</ArgonTypography>,
    "Discovery Call Status": <ArgonBadge variant="gradient" badgeContent="Completed" color="success" size="xs" container />,
    "Discovery CallDate": <ArgonTypography variant="caption" color="text" fontWeight="medium">12 Dec 2024</ArgonTypography>,
    "Location": <ArgonTypography variant="caption" color="text" fontWeight="medium">Mumbai</ArgonTypography>,
    "LastEHCDate": <ArgonTypography variant="caption" color="text" fontWeight="medium">10 Dec 2024</ArgonTypography>,
    "LastSRCDate": <ArgonTypography variant="caption" color="text" fontWeight="medium">08 Dec 2024</ArgonTypography>,
    "Class Status": <ArgonBadge variant="gradient" badgeContent="Active" color="success" size="xs" container />,
    "EHCTestStatus": <ArgonBadge variant="gradient" badgeContent="Passed" color="info" size="xs" container />,
    "EHC ManagerName & Mobile": <Author image={team4} name="Amit Kumar" email="9988776655" />,
    "ClassRemaining %": <ArgonTypography variant="caption" color="text" fontWeight="medium">75%</ArgonTypography>,
  },
  {
    sno1: <ArgonTypography variant="caption" color="text" fontWeight="medium">2</ArgonTypography>,
    "Parent Name & Mobile": <Author image={team3} name="Sunita Gupta" email="9876543211" />,
    "Educator Name & Mobile": <Author image={team2} name="Prof. Vikash Singh" email="9123456788" />,
    "Invegilator Date & Time": <ArgonTypography variant="caption" color="text" fontWeight="medium">18 Dec 2024, 2:00 PM</ArgonTypography>,
    "Discovery Call Status": <ArgonBadge variant="gradient" badgeContent="Pending" color="warning" size="xs" container />,
    "Discovery CallDate": <ArgonTypography variant="caption" color="text" fontWeight="medium">16 Dec 2024</ArgonTypography>,
    "Location": <ArgonTypography variant="caption" color="text" fontWeight="medium">Delhi</ArgonTypography>,
    "LastEHCDate": <ArgonTypography variant="caption" color="text" fontWeight="medium">14 Dec 2024</ArgonTypography>,
    "LastSRCDate": <ArgonTypography variant="caption" color="text" fontWeight="medium">12 Dec 2024</ArgonTypography>,
    "Class Status": <ArgonBadge variant="gradient" badgeContent="Inactive" color="secondary" size="xs" container />,
    "EHCTestStatus": <ArgonBadge variant="gradient" badgeContent="Failed" color="error" size="xs" container />,
    "EHC ManagerName & Mobile": <Author image={team2} name="Sneha Patel" email="9988776654" />,
    "ClassRemaining %": <ArgonTypography variant="caption" color="text" fontWeight="medium">45%</ArgonTypography>,
  },
//   {
//     sno1: <ArgonTypography variant="caption" color="text" fontWeight="medium">3</ArgonTypography>,
//     "Parent Name & Mobile": <Author image={team4} name="Ramesh Kumar" email="9876543212" />,
//     "Educator Name & Mobile": <Author image={team3} name="Dr. Kavita Sharma" email="9123456787" />,
//     "Invegilator Date & Time": <ArgonTypography variant="caption" color="text" fontWeight="medium">20 Dec 2024, 11:30 AM</ArgonTypography>,
//     "Discovery Call Status": <ArgonBadge variant="gradient" badgeContent="Scheduled" color="info" size="xs" container />,
//     "Discovery CallDate": <ArgonTypography variant="caption" color="text" fontWeight="medium">19 Dec 2024</ArgonTypography>,
//     "Location": <ArgonTypography variant="caption" color="text" fontWeight="medium">Bangalore</ArgonTypography>,
//     "LastEHCDate": <ArgonTypography variant="caption" color="text" fontWeight="medium">17 Dec 2024</ArgonTypography>,
//     "LastSRCDate": <ArgonTypography variant="caption" color="text" fontWeight="medium">15 Dec 2024</ArgonTypography>,
//     "Class Status": <ArgonBadge variant="gradient" badgeContent="Active" color="success" size="xs" container />,
//     "EHCTestStatus": <ArgonBadge variant="gradient" badgeContent="In Progress" color="warning" size="xs" container />,
//     "EHC ManagerName & Mobile": <Author image={team4} name="Rohit Verma" email="9988776653" />,
//     "ClassRemaining %": <ArgonTypography variant="caption" color="text" fontWeight="medium">90%</ArgonTypography>,
//   },
//    {
//     sno1: <ArgonTypography variant="caption" color="text" fontWeight="medium">3</ArgonTypography>,
//     "Parent Name & Mobile": <Author image={team4} name="Ramesh Kumar" email="9876543212" />,
//     "Educator Name & Mobile": <Author image={team3} name="Dr. Kavita Sharma" email="9123456787" />,
//     "Invegilator Date & Time": <ArgonTypography variant="caption" color="text" fontWeight="medium">20 Dec 2024, 11:30 AM</ArgonTypography>,
//     "Discovery Call Status": <ArgonBadge variant="gradient" badgeContent="Scheduled" color="info" size="xs" container />,
//     "Discovery CallDate": <ArgonTypography variant="caption" color="text" fontWeight="medium">19 Dec 2024</ArgonTypography>,
//     "Location": <ArgonTypography variant="caption" color="text" fontWeight="medium">Bangalore</ArgonTypography>,
//     "LastEHCDate": <ArgonTypography variant="caption" color="text" fontWeight="medium">17 Dec 2024</ArgonTypography>,
//     "LastSRCDate": <ArgonTypography variant="caption" color="text" fontWeight="medium">15 Dec 2024</ArgonTypography>,
//     "Class Status": <ArgonBadge variant="gradient" badgeContent="Active" color="success" size="xs" container />,
//     "EHCTestStatus": <ArgonBadge variant="gradient" badgeContent="In Progress" color="warning" size="xs" container />,
//     "EHC ManagerName & Mobile": <Author image={team4} name="Rohit Verma" email="9988776653" />,
//     "ClassRemaining %": <ArgonTypography variant="caption" color="text" fontWeight="medium">90%</ArgonTypography>,
//   },
//    {
//     sno1: <ArgonTypography variant="caption" color="text" fontWeight="medium">3</ArgonTypography>,
//     "Parent Name & Mobile": <Author image={team4} name="Ramesh Kumar" email="9876543212" />,
//     "Educator Name & Mobile": <Author image={team3} name="Dr. Kavita Sharma" email="9123456787" />,
//     "Invegilator Date & Time": <ArgonTypography variant="caption" color="text" fontWeight="medium">20 Dec 2024, 11:30 AM</ArgonTypography>,
//     "Discovery Call Status": <ArgonBadge variant="gradient" badgeContent="Scheduled" color="info" size="xs" container />,
//     "Discovery CallDate": <ArgonTypography variant="caption" color="text" fontWeight="medium">19 Dec 2024</ArgonTypography>,
//     "Location": <ArgonTypography variant="caption" color="text" fontWeight="medium">Bangalore</ArgonTypography>,
//     "LastEHCDate": <ArgonTypography variant="caption" color="text" fontWeight="medium">17 Dec 2024</ArgonTypography>,
//     "LastSRCDate": <ArgonTypography variant="caption" color="text" fontWeight="medium">15 Dec 2024</ArgonTypography>,
//     "Class Status": <ArgonBadge variant="gradient" badgeContent="Active" color="success" size="xs" container />,
//     "EHCTestStatus": <ArgonBadge variant="gradient" badgeContent="In Progress" color="warning" size="xs" container />,
//     "EHC ManagerName & Mobile": <Author image={team4} name="Rohit Verma" email="9988776653" />,
//     "ClassRemaining %": <ArgonTypography variant="caption" color="text" fontWeight="medium">90%</ArgonTypography>,
//   },
//    {
//     sno1: <ArgonTypography variant="caption" color="text" fontWeight="medium">3</ArgonTypography>,
//     "Parent Name & Mobile": <Author image={team4} name="Ramesh Kumar" email="9876543212" />,
//     "Educator Name & Mobile": <Author image={team3} name="Dr. Kavita Sharma" email="9123456787" />,
//     "Invegilator Date & Time": <ArgonTypography variant="caption" color="text" fontWeight="medium">20 Dec 2024, 11:30 AM</ArgonTypography>,
//     "Discovery Call Status": <ArgonBadge variant="gradient" badgeContent="Scheduled" color="info" size="xs" container />,
//     "Discovery CallDate": <ArgonTypography variant="caption" color="text" fontWeight="medium">19 Dec 2024</ArgonTypography>,
//     "Location": <ArgonTypography variant="caption" color="text" fontWeight="medium">Bangalore</ArgonTypography>,
//     "LastEHCDate": <ArgonTypography variant="caption" color="text" fontWeight="medium">17 Dec 2024</ArgonTypography>,
//     "LastSRCDate": <ArgonTypography variant="caption" color="text" fontWeight="medium">15 Dec 2024</ArgonTypography>,
//     "Class Status": <ArgonBadge variant="gradient" badgeContent="Active" color="success" size="xs" container />,
//     "EHCTestStatus": <ArgonBadge variant="gradient" badgeContent="In Progress" color="warning" size="xs" container />,
//     "EHC ManagerName & Mobile": <Author image={team4} name="Rohit Verma" email="9988776653" />,
//     "ClassRemaining %": <ArgonTypography variant="caption" color="text" fontWeight="medium">90%</ArgonTypography>,
//   },
//    {
//     sno1: <ArgonTypography variant="caption" color="text" fontWeight="medium">3</ArgonTypography>,
//     "Parent Name & Mobile": <Author image={team4} name="Ramesh Kumar" email="9876543212" />,
//     "Educator Name & Mobile": <Author image={team3} name="Dr. Kavita Sharma" email="9123456787" />,
//     "Invegilator Date & Time": <ArgonTypography variant="caption" color="text" fontWeight="medium">20 Dec 2024, 11:30 AM</ArgonTypography>,
//     "Discovery Call Status": <ArgonBadge variant="gradient" badgeContent="Scheduled" color="info" size="xs" container />,
//     "Discovery CallDate": <ArgonTypography variant="caption" color="text" fontWeight="medium">19 Dec 2024</ArgonTypography>,
//     "Location": <ArgonTypography variant="caption" color="text" fontWeight="medium">Bangalore</ArgonTypography>,
//     "LastEHCDate": <ArgonTypography variant="caption" color="text" fontWeight="medium">17 Dec 2024</ArgonTypography>,
//     "LastSRCDate": <ArgonTypography variant="caption" color="text" fontWeight="medium">15 Dec 2024</ArgonTypography>,
//     "Class Status": <ArgonBadge variant="gradient" badgeContent="Active" color="success" size="xs" container />,
//     "EHCTestStatus": <ArgonBadge variant="gradient" badgeContent="In Progress" color="warning" size="xs" container />,
//     "EHC ManagerName & Mobile": <Author image={team4} name="Rohit Verma" email="9988776653" />,
//     "ClassRemaining %": <ArgonTypography variant="caption" color="text" fontWeight="medium">90%</ArgonTypography>,
//   },
]


//   rows: [
//     {
//       sno1: <ArgonTypography variant="caption" color="text" fontWeight="medium">{"1"}</ArgonTypography>,
//       Class_name: <ArgonTypography variant="caption" color="text" fontWeight="medium">{"Mathematics Grade 10"}</ArgonTypography>,
//       student:  <StudentData student={"Aarav Sharma"} client={"Rajesh Sharma"} />,
//       tutor: <ArgonTypography variant="caption" color="text" fontWeight="medium">{"Dr.Priya Patel"}</ArgonTypography>,
//       Last_attendance_marked: <AttendanceProgress percentage={"50"}/>,
//       mode:<ArgonTypography variant="caption" color="text" fontWeight="medium">{"7354722929"}</ArgonTypography>,
//       status:(<ArgonBadge variant="gradient" badgeContent="online" color="success" size="xs" container />),
//          action: (
//   <ArgonBox display="flex" alignItems="center" gap={1}>
//     {/* View Icon */}
//     <ArgonTypography component="a" href="#" variant="body1" color="primary" fontWeight="medium">
//       <VisibilityIcon/>
//     </ArgonTypography>

//     {/* Delete Icon */}
//     <ArgonTypography component="a" href="#" variant="body1" color="error" fontWeight="medium">
//     <DeleteIcon/>
//     </ArgonTypography>
//   </ArgonBox>
// ),
// },
//    {
//       sno1: <ArgonTypography variant="caption" color="text" fontWeight="medium">{"1"}</ArgonTypography>,
//       Class_name: <ArgonTypography variant="caption" color="text" fontWeight="medium">{"Mathematics Grade 10"}</ArgonTypography>,
//       student:  <StudentData student={"Aarav Sharma"} client={"Rajesh Sharma"} />,
//       tutor: <ArgonTypography variant="caption" color="text" fontWeight="medium">{"Dr.Priya Patel"}</ArgonTypography>,
//       Last_attendance_marked: <AttendanceProgress percentage={"50"}/>,
//       mode:<ArgonTypography variant="caption" color="text" fontWeight="medium">{"7354722929"}</ArgonTypography>,
//       status:(<ArgonBadge variant="gradient" badgeContent="online" color="success" size="xs" container />),
//          action: (
//   <ArgonBox display="flex" alignItems="center" gap={1}>
//     {/* View Icon */}
//     <ArgonTypography component="a" href="#" variant="body1" color="primary" fontWeight="medium">
//       <VisibilityIcon/>
//     </ArgonTypography>

//     {/* Delete Icon */}
//     <ArgonTypography component="a" href="#" variant="body1" color="error" fontWeight="medium">
//     <DeleteIcon/>
//     </ArgonTypography>
//   </ArgonBox>
// ),
// },
//    {
//       sno1: <ArgonTypography variant="caption" color="text" fontWeight="medium">{"1"}</ArgonTypography>,
//       Class_name: <ArgonTypography variant="caption" color="text" fontWeight="medium">{"Mathematics Grade 10"}</ArgonTypography>,
//       student:  <StudentData student={"Aarav Sharma"} client={"Rajesh Sharma"} />,
//       tutor: <ArgonTypography variant="caption" color="text" fontWeight="medium">{"Dr.Priya Patel"}</ArgonTypography>,
//       Last_attendance_marked: <AttendanceProgress percentage={"50"}/>,
//       mode:<ArgonTypography variant="caption" color="text" fontWeight="medium">{"7354722929"}</ArgonTypography>,
//       status:(<ArgonBadge variant="gradient" badgeContent="online" color="success" size="xs" container />),
//          action: (
//   <ArgonBox display="flex" alignItems="center" gap={1}>
//     {/* View Icon */}
//     <ArgonTypography component="a" href="#" variant="body1" color="primary" fontWeight="medium">
//       <VisibilityIcon/>
//     </ArgonTypography>

//     {/* Delete Icon */}
//     <ArgonTypography component="a" href="#" variant="body1" color="error" fontWeight="medium">
//     <DeleteIcon/>
//     </ArgonTypography>
//   </ArgonBox>
// ),
// },
//    {
//       sno1: <ArgonTypography variant="caption" color="text" fontWeight="medium">{"1"}</ArgonTypography>,
//       Class_name: <ArgonTypography variant="caption" color="text" fontWeight="medium">{"Mathematics Grade 10"}</ArgonTypography>,
//       student:  <StudentData student={"Aarav Sharma"} client={"Rajesh Sharma"} />,
//       tutor: <ArgonTypography variant="caption" color="text" fontWeight="medium">{"Dr.Priya Patel"}</ArgonTypography>,
//       Last_attendance_marked: <AttendanceProgress percentage={"50"}/>,
//       mode:<ArgonTypography variant="caption" color="text" fontWeight="medium">{"7354722929"}</ArgonTypography>,
//       status:(<ArgonBadge variant="gradient" badgeContent="online" color="success" size="xs" container />),
//          action: (
//   <ArgonBox display="flex" alignItems="center" gap={1}>
//     {/* View Icon */}
//     <ArgonTypography component="a" href="#" variant="body1" color="primary" fontWeight="medium">
//       <VisibilityIcon/>
//     </ArgonTypography>

//     {/* Delete Icon */}
//     <ArgonTypography component="a" href="#" variant="body1" color="error" fontWeight="medium">
//     <DeleteIcon/>
//     </ArgonTypography>
//   </ArgonBox>
// ),
// },
//    {
//       sno1: <ArgonTypography variant="caption" color="text" fontWeight="medium">{"1"}</ArgonTypography>,
//       Class_name: <ArgonTypography variant="caption" color="text" fontWeight="medium">{"Mathematics Grade 10"}</ArgonTypography>,
//       student:  <StudentData student={"Aarav Sharma"} client={"Rajesh Sharma"} />,
//       tutor: <ArgonTypography variant="caption" color="text" fontWeight="medium">{"Dr.Priya Patel"}</ArgonTypography>,
//       Last_attendance_marked: <AttendanceProgress percentage={"50"}/>,
//       mode:<ArgonTypography variant="caption" color="text" fontWeight="medium">{"7354722929"}</ArgonTypography>,
//       status:(<ArgonBadge variant="gradient" badgeContent="online" color="success" size="xs" container />),
//          action: (
//   <ArgonBox display="flex" alignItems="center" gap={1}>
//     {/* View Icon */}
//     <ArgonTypography component="a" href="#" variant="body1" color="primary" fontWeight="medium">
//       <VisibilityIcon/>
//     </ArgonTypography>

//     {/* Delete Icon */}
//     <ArgonTypography component="a" href="#" variant="body1" color="error" fontWeight="medium">
//     <DeleteIcon/>
//     </ArgonTypography>
//   </ArgonBox>
// ),
// },
//    {
//       sno1: <ArgonTypography variant="caption" color="text" fontWeight="medium">{"1"}</ArgonTypography>,
//       Class_name: <ArgonTypography variant="caption" color="text" fontWeight="medium">{"Mathematics Grade 10"}</ArgonTypography>,
//       student:  <StudentData student={"Aarav Sharma"} client={"Rajesh Sharma"} />,
//       tutor: <ArgonTypography variant="caption" color="text" fontWeight="medium">{"Dr.Priya Patel"}</ArgonTypography>,
//       Last_attendance_marked: <AttendanceProgress percentage={"50"}/>,
//       mode:<ArgonTypography variant="caption" color="text" fontWeight="medium">{"7354722929"}</ArgonTypography>,
//       status:(<ArgonBadge variant="gradient" badgeContent="online" color="success" size="xs" container />),
//          action: (
//   <ArgonBox display="flex" alignItems="center" gap={1}>
//     {/* View Icon */}
//     <ArgonTypography component="a" href="#" variant="body1" color="primary" fontWeight="medium">
//       <VisibilityIcon/>
//     </ArgonTypography>

//     {/* Delete Icon */}
//     <ArgonTypography component="a" href="#" variant="body1" color="error" fontWeight="medium">
//     <DeleteIcon/>
//     </ArgonTypography>
//   </ArgonBox>
// ),
// },

 
   
    
   
    


//     // {
//     //   author: <Author image={team2} name="John Michael" email="john@creative-tim.com" />,
//     //   function: <Function job="Manager" org="Organization" />,
//     //   status: (
//     //     <ArgonBadge variant="gradient" badgeContent="online" color="success" size="xs" container />
//     //   ),
//     //   employed: (
//     //     <ArgonTypography variant="caption" color="secondary" fontWeight="medium">
//     //       23/04/18
//     //     </ArgonTypography>
//     //   ),
//     //   action: (
//     //     <ArgonTypography
//     //       component="a"
//     //       href="#"
//     //       variant="caption"
//     //       color="secondary"
//     //       fontWeight="medium"
//     //     >
//     //       Edit
//     //     </ArgonTypography>
//     //   ),
//     // },


//     // {
//     //   author: <Author image={team3} name="Alexa Liras" email="alexa@creative-tim.com" />,
//     //   function: <Function job="Programator" org="Developer" />,
//     //   status: (
//     //     <ArgonBadge variant="gradient" badgeContent="offline" color="secondary" size="xs" container />
//     //   ),
//     //   employed: (
//     //     <ArgonTypography variant="caption" color="secondary" fontWeight="medium">
//     //       11/01/19
//     //     </ArgonTypography>
//     //   ),
//     //   action: (
//     //     <ArgonTypography
//     //       component="a"
//     //       href="#"
//     //       variant="caption"
//     //       color="secondary"
//     //       fontWeight="medium"
//     //     >
//     //       Edit
//     //     </ArgonTypography>
//     //   ),
//     // },
//     // {
//     //   author: <Author image={team4} name="Laurent Perrier" email="laurent@creative-tim.com" />,
//     //   function: <Function job="Executive" org="Projects" />,
//     //   status: (
//     //     <ArgonBadge variant="gradient" badgeContent="online" color="success" size="xs" container />
//     //   ),
//     //   employed: (
//     //     <ArgonTypography variant="caption" color="secondary" fontWeight="medium">
//     //       19/09/17
//     //     </ArgonTypography>
//     //   ),
//     //   action: (
//     //     <ArgonTypography
//     //       component="a"
//     //       href="#"
//     //       variant="caption"
//     //       color="secondary"
//     //       fontWeight="medium"
//     //     >
//     //       Edit
//     //     </ArgonTypography>
//     //   ),
//     // },
//     // {
//     //   author: <Author image={team3} name="Michael Levi" email="michael@creative-tim.com" />,
//     //   function: <Function job="Programator" org="Developer" />,
//     //   status: (
//     //     <ArgonBadge variant="gradient" badgeContent="online" color="success" size="xs" container />
//     //   ),
//     //   employed: (
//     //     <ArgonTypography variant="caption" color="secondary" fontWeight="medium">
//     //       24/12/08
//     //     </ArgonTypography>
//     //   ),
//     //   action: (
//     //     <ArgonTypography
//     //       component="a"
//     //       href="#"
//     //       variant="caption"
//     //       color="secondary"
//     //       fontWeight="medium"
//     //     >
//     //       Edit
//     //     </ArgonTypography>
//     //   ),
//     // },
//     // {
//     //   author: <Author image={team2} name="Richard Gran" email="richard@creative-tim.com" />,
//     //   function: <Function job="Manager" org="Executive" />,
//     //   status: (
//     //     <ArgonBadge variant="gradient" badgeContent="offline" color="secondary" size="xs" container />
//     //   ),
//     //   employed: (
//     //     <ArgonTypography variant="caption" color="secondary" fontWeight="medium">
//     //       04/10/21
//     //     </ArgonTypography>
//     //   ),
//     //   action: (
//     //     <ArgonTypography
//     //       component="a"
//     //       href="#"
//     //       variant="caption"
//     //       color="secondary"
//     //       fontWeight="medium"
//     //     >
//     //       Edit
//     //     </ArgonTypography>
//     //   ),
//     // },
//     // {
//     //   author: <Author image={team4} name="Miriam Eric" email="miriam@creative-tim.com" />,
//     //   function: <Function job="Programtor" org="Developer" />,
//     //   status: (
//     //     <ArgonBadge variant="gradient" badgeContent="offline" color="secondary" size="xs" container />
//     //   ),
//     //   employed: (
//     //     <ArgonTypography variant="caption" color="secondary" fontWeight="medium">
//     //       14/09/20
//     //     </ArgonTypography>
//     //   ),
//     //   action: (
//     //     <ArgonTypography
//     //       component="a"
//     //       href="#"
//     //       variant="caption"
//     //       color="secondary"
//     //       fontWeight="medium"
//     //     >
//     //       Edit
//     //     </ArgonTypography>
//     //   ),
//     // },
//   ],
};

export default authorsTableData;
